// This controller is designed to be used as part of a form where all the possible "items"
// have the ability to enable/disable the "button" target by toggling the "disabled" attribute
// of the button and therefore allowing the form to be submitted.

import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["item", "button"];

  declare itemTargets: Array<HTMLInputElement>;
  declare buttonTarget: HTMLInputElement;

  connect() {
    if (this.areAnyItemsActive()) {
      this.buttonTarget.removeAttribute("disabled");
    }
  }

  toggle() {
    this.buttonTarget.toggleAttribute("disabled", !this.areAnyItemsActive());
  }

  areAnyItemsActive() {
    return this.itemTargets.some((item) => item.checked);
  }
}
